interface Company {
  externalRolePrice: number
  freeExternalUserIds?: number[]
}

interface ExternalContributorRole {
  userId: number
}

export function userUrl(userId: number): string {
  return window.Silverfin.Routes.edit_user_path(
    window.Silverfin.currentFirmId,
    userId
  )
}

export function showExternalIsPaid(
  company: Company,
  externalContributorRoles: ExternalContributorRole[]
): boolean {
  if (company.externalRolePrice === 0) return false

  const allExternalsAreFree =
    company.freeExternalUserIds &&
    externalContributorRoles.filter(
      (role) => !company.freeExternalUserIds!.includes(role.userId)
    ).length === 0

  return externalContributorRoles.length === 0 || !!allExternalsAreFree
}
